<div class="form-group mb-20">
    <label class="col-xs-12">
        {{ "hover_effects_label" | translate }}
    </label>

    <div class="col-xs-{{ columnWidth.select }}">
        <select (change)="setType($event)" class="form-control">
            <option
                *ngFor="let option of effectsOptions"
                [value]="option.value"
                [selected]="option.value === type.value"
            >
                {{ option.label | translate }}
            </option>
        </select>
    </div>

    <div class="col-xs-{{ columnWidth.value }}" [ngSwitch]="type.value">
        <sp-input-num
            suffixText="%"
            [max]="TRANSPARENCY_SIZE_MAX"
            [min]="50"
            [step]="5"
            [value]="transparency.value"
            (valueChange)="setTransparencySize($event)"
            *ngSwitchCase="EffectTypes.transparency"
        ></sp-input-num>

        <web-color-picker
            [hideGradient]="true"
            [color]="color.value"
            (colorChangeEvent)="setColor($event)"
            *ngSwitchCase="EffectTypes.color"
        ></web-color-picker>

        <ng-container *ngSwitchCase="EffectTypes.underline">
            <div class="form-row mt-10">
                <div class="form-group">
                    <div class="col-xs-4">
                        <sp-input-num
                            suffixText="px"
                            [max]="6"
                            [min]="1"
                            [value]="lineWidth.value"
                            (valueChange)="setLineWidth($event)"
                        ></sp-input-num>
                    </div>
                    <div class="col-xs-6">
                        <select (change)="setUnderlineType($event)" class="form-control">
                            <option
                                *ngFor="let option of underlineOptions"
                                [value]="option.value"
                                [selected]="option.value === lineType.value"
                            >
                                {{ option.label | translate }}
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-2">
                        <web-color-picker
                            [hideGradient]="true"
                            [color]="color.value"
                            (colorChangeEvent)="setColor($event)"
                        ></web-color-picker>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="EffectTypes.animation">
            <div class="form-row mt-10">
                <div class="form-group">
                    <div class="col-xs-12">
                        <select (change)="setAnimationType($event)" class="form-control">
                            <option
                                *ngFor="let option of animationTypes"
                                [value]="option.value"
                                [selected]="option.value === animationType.value"
                            >
                                {{ option.label | translate }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
